@if (data) {
  <div class="survey-footer-section"
    [style.background-color]="data.backgroundColor">
    <div class="survey-footer-inner"
      [style.align-items]="data.alignment"
      [style.text-align]="data.textAlign">
      <div class="survey-footer-title m-0"
        [style.color]="data.contentColor"
        [style.font-size]="data.contentFontSize + 'px'"
        [style.font-family]="data.contentFontFamily"
        [style.font-weight]="data.contentFontWeight">
        {{ data.content }}
      </div>
      @if (data.linkLabel) {
        <a class="survey-footer-link" [href]="data.linkUrl || '#'" [attr.target]="data.linkUrl ? '_blank' : null">
          {{ data.linkLabel }}
        </a>
      }
    </div>
    @if (!data.promotionFlag) {
      <div class="survey-footer-powered-by">
        <span>Powered by </span>
        <img src="assets/images/logo/ICXBEE.svg" alt="ICXBee logo" />
      </div>
    }
  </div>
}
